import { useQuery } from "react-query";
import { RQ_KEY } from "../../constants/query";
import { getUserResults } from "../../services/users";
import { TResultsQuery } from "../schemas/user";

export default function useQueryResultsUser() {
  return useQuery<TResultsQuery[], Error>([RQ_KEY.USER_RESULTS], () => getUserResults());
}
